import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = {
  style: {"margin-top":"4px","margin-bottom":"4px"},
  class: "col-md-10 col-12 float-start"
}
const _hoisted_3 = { class: "col-6 float-start" }
const _hoisted_4 = { class: "col-6 float-start" }
const _hoisted_5 = { class: "col-3 float-start" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"50%","float":"left"} }, " 時 ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-3 float-end" }, "から", -1)
const _hoisted_9 = { class: "col-6 float-start" }
const _hoisted_10 = { class: "col-6 float-start" }
const _hoisted_11 = { class: "col-3 float-start" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"50%","float":"left"} }, " 時 ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-3 float-end" }, null, -1)
const _hoisted_15 = {
  style: {"margin-top":"4px","margin-bottom":"4px"},
  class: "col-md-2 col-12 float-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, _toDisplayString($data.settings.description), 1),
    _createTextVNode(),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.dateInputChanged && $options.dateInputChanged(...args))),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.startDate) = $event)),
            type: "date",
            id: "start",
            min: "2020-01-01",
            max: "2100-12-31"
          }, null, 544), [
            [_vModelText, $data.startDate]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            style: {"width":"48%","float":"left","margin-left":"2%"},
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.starthour) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hours, (hour) => {
              return (_openBlock(), _createElementBlock("option", {
                key: hour,
                value: hour.value
              }, _toDisplayString(hour.label), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, $data.starthour]
          ]),
          _createTextVNode(),
          _hoisted_7
        ], 512), [
          [_vShow, $data.settings.vstarthourname && $data.settings.vstarthourname !='' ]
        ]),
        _hoisted_8
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.dateInputChanged && $options.dateInputChanged(...args))),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.endDate) = $event)),
            t: "",
            type: "date",
            id: "end",
            min: "2020-01-01",
            max: "2100-12-31"
          }, null, 544), [
            [_vModelText, $data.endDate]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("select", {
            style: {"width":"48%","float":"left","margin-left":"2%"},
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.endhour) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hours, (hour) => {
              return (_openBlock(), _createElementBlock("option", {
                key: hour,
                value: hour.value
              }, _toDisplayString(hour.label), 9, _hoisted_12))
            }), 128))
          ], 512), [
            [_vModelSelect, $data.endhour]
          ]),
          _hoisted_13
        ], 512), [
          [_vShow, $data.settings.vendhourname && $data.settings.vendhourname !='' ]
        ]),
        _hoisted_14
      ], 512), [
        [_vShow, $data.settings.needEnd]
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        class: "btn btn-dark",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.set && $options.set(...args)))
      }, " 設定する ")
    ])
  ], 64))
}